import { useState, useEffect } from "react";
import { useGetCoursesQuery } from "src/services/CourseServices";

const useCourse = () => {
  const [course, setCourse] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const {
    data ,
    isLoading , 
    isFetching,
  } = useGetCoursesQuery({
    limit: 10,
    searchValue: "",
    params: [
      "courseName",
      "courseDescription",
      "classroomFees",
      "onlineFees",
      "moduleId",
    ],
    page: 1,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setCourse(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { course, isDataLoading };
};

export default useCourse;
